import { POP_ALERT, DESTROY_ALERT } from '../actions/types';

const initialState = {
    alerts:[]
}


export default function (state = initialState, action) {
    
    switch (action.type) {
        case POP_ALERT: return { ...state, alerts: [...state.alerts, action.payload] };
        case DESTROY_ALERT: return { ...state, alerts: state.alerts.filter(alert => alert.id !== action.payload) };
        default: return state;
    }
}